export default "__VITE_ASSET__LQa7pALT__"